var ModuleType;
(function(ModuleType) {
    ModuleType["Columns"] = "columns";
    ModuleType["Container"] = "container";
    ModuleType["ContentModule"] = "content-module";
})(ModuleType || (ModuleType = {}));
export { ModuleType };
